import { Item } from './itemList';

export interface TopLevelOpenOrderSearch {
  openOrders: OpenOrderSearchResult[];
}

export interface TopLevelItemSearch {
  items: Item[];
}

export interface OpenOrder {
  orderNumber: number;
  orderSuffix: number;
  sortableOrderNumber: number;
  customerNumber: number;
  transactionTypeCode: string;
  fullOrderNumber: string;
  customerPO: string;
  reference: string;
  carrier: string;
  requiredShipDate: Date;
  createDate: Date;
  promisedDate: Date;
  invoicedDate: Date;
  shippedDate: Date;
  total: number;
  totalShipped: number;
  totalInvoiced: number;
  approveType: string;
  orderDisposition: string;
  stageCode: number;
  shipToNumber: string;
  shipToCity: string;
  shipToState: string;
  shipToZip: string;
  shipToAddress1: string;
  shipToAddress2: string;
  termsType: string;
  termsDescription: string;
  shipToName: string;
  warehouseName: string;
  warehouseCode: string;
  trackingNumber: null;
  transactionType: string;
  stage: string;
  holdReason: string;
  onHold: string;
  shipComplete?: string;
  note: null;
}

export interface OpenOrderSearchResult {
  orderNumber: number;
  orderSuffix: number;
  customerNumber?: number;
  vendorPO?: string;
  customerPO?: string;
  fullOrderNumber: string;
}

export const defaultTopLevelOpenOrderSearch: TopLevelOpenOrderSearch = {
  openOrders: [],
};

export const defaultTopLevelItemSearch: TopLevelItemSearch = {
  items: [],
};
